import { makeStyles } from 'tss-react/mui';
import { getGridSurface } from './gridScrollFade';

interface UseOrderProductGridStylesParams {
  hasTouchGrid: boolean;
}

const useOrderProductGridStyles = makeStyles<UseOrderProductGridStylesParams>()(
  (theme, { hasTouchGrid }) => {
    const hoverBackgroundColor = hasTouchGrid
      ? theme.palette.background.paper
      : theme.palette.action.hover;

    return {
      root: {
        '&:hover': {
          backgroundColor: hoverBackgroundColor,
          ...getGridSurface({ base: hoverBackgroundColor }),
          '& .arrow': {
            color: theme.palette.text.primary,
          },
        },
      },
    };
  },
);

export default useOrderProductGridStyles;
